var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1259_3679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 26.5264C20.1799 26.5264 26 20.7063 26 13.5264C26 6.34647 20.1799 0.526367 13 0.526367C5.8201 0.526367 0 6.34647 0 13.5264C0 20.7063 5.8201 26.5264 13 26.5264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11719 14.3669L10.479 17.7288L18.8835 9.32422",
    stroke: "url(#paint0_linear_1259_3679)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1259_3679",
    x1: 5.39205,
    y1: 3.74415,
    x2: 24.2609,
    y2: 8.45984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27C69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C7BDF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1259_3679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.526367)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickActive);
export default __webpack_public_path__ + "static/media/tick_active.cad4ac2d3e2833b96c4f6ee700eaff8f.svg";
export { ForwardRef as ReactComponent };